const systemHelper = {
  /**
   * Returns a the current iOS version
   * @param {Boolean} includeMinor - Whether to include the minor version
   * @returns {Number} The current iOS version (-1 means no version was found)
   */
  iOSVersion(includeMinor) {
    const match = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
    if (!match) {
      return -1;
    }

    const version = [
      parseInt(match[1], 10),
      parseInt(match[2], 10),
      parseInt(match[3] || 0, 10),
    ];

    if (!includeMinor) {
      return version[0];
    }

    return parseFloat(version.join('.'));
  },
};

export default systemHelper;
